import React from 'react'
import { Link } from 'react-router-dom'
import '../../../assets/scss/components/Shared/NavigationButton/nagivation-button.css'
/* This component is a styled <Link /> with appearance link button
    Props
        [message] - the text that is displayed on the button
        [url] - the redirecting address
        [styleType] - the style that this componet should follow
        [actionType] - is this a button or a link?
        [actionFunction] - if this is a button, what is the function that is associated with this button onclick?
    Two style choices (current -> more can be added depening on need)
        [blue] - blue background / white text
        [white] - white background / blue text / gray border
*/

const NavigationButton = ({ message, url, styleType, actionType, actionFunction, isExternal }) => {
    if (actionType === 'link') {
        return isExternal ? (
            <a
                className={styleType ? `NavigationButton_${styleType}` : `NavigationButton_blue`}
                href={url}
                target="_blank"
                onClick={actionFunction}
            >
                {message}
            </a>
        ) : (
            <Link
                className={styleType ? `NavigationButton_${styleType}` : `NavigationButton_blue`}
                to={url}
                onClick={actionFunction}
            >
                {message}
            </Link>
        )
    } else if (actionType === 'button') {
        return (
            <button
                className={
                    styleType
                        ? `NavigationButton_${styleType}_button`
                        : `NavigationButton_blue_button`
                }
                target="_blank"
                onClick={actionFunction}>
                {message}
            </button>
        )
    }
}

export default NavigationButton
